/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InputContainerModule } from '@ng-falcon/controls/input-container/input-container.module';

@Component({
    selector: 'ngf-tester-navigation-header-search',
    templateUrl: './tester-navigation-header-search.component.html',
    styleUrls: ['./tester-navigation-header-search.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [FormsModule, InputContainerModule]
})
export class TesterNavigationHeaderSearchComponent {
  @Input() set searchQuery(value: string) {
    this.query = value ?? '';
  }

  @Output() searchSubmit = new EventEmitter<string>();

  query = '';

  onSubmit(): void {
    if (this.query.trim()) {
      this.searchSubmit.emit(this.query.trim());
    }
  }
}
